export default __webpack_public_path__ + "static/media/airstrapz-blk-3.330c30f5.png";